module.exports = __webpack_public_path__ + "static/media/3.10_preview.6104f899.png";